import { SectionLabel } from '../ui/SectionLabel'

const cx = 'max-w-[1100px] mx-auto px-5 sm:px-8'

const STEPS = [
  {
    num: '01',
    title: 'Configura tu perfil',
    body: 'Cuéntale al AI quién eres, qué estás construyendo y para quién creas. 4 pasos, 3 minutos. Una vez y para siempre.',
  },
  {
    num: '02',
    title: 'Crea un proyecto',
    body: 'Añade título, plataforma y notas de tu próximo vídeo. El AI tiene el contexto que necesita para entender tu intención.',
  },
  {
    num: '03',
    title: 'Genera el guion',
    body: 'Un clic. Guion completo en tu voz, con estructura narrativa, notas visuales y frases clave. Listo para grabar.',
  },
]

export function HowItWorks() {
  return (
    <section id="como-funciona" className="py-24 border-b border-ds-border">
      <div className={cx}>
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-6 lg:gap-16 mb-16 items-end">
          <div>
            <SectionLabel className="mb-5">Cómo funciona</SectionLabel>
            <h2 className="font-display font-black text-display-md tracking-tight2 uppercase text-ds-text">
              De la idea
              <br />
              al guion{' '}
              <span className="italic text-ds-red">
                en
                <br />
                minutos.
              </span>
            </h2>
          </div>
          <p className="font-sans text-[15px] text-ds-muted leading-[1.7] max-w-[420px]">
            Sin fricción, sin plantillas genéricas, sin perder el tiempo. Tres pasos que te llevan
            desde lo que tienes en la cabeza hasta un guion que suena exactamente como tú.
          </p>
        </div>

        {/* Gap trick: bg shows through gap as divider lines */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-[1px] bg-ds-border border border-ds-border">
          {STEPS.map(({ num, title, body }) => (
            <div
              key={num}
              className="bg-ds-bg px-9 py-10 hover:bg-ds-surface transition-colors duration-200"
            >
              <div className="font-display font-black text-[80px] tracking-[-0.03em] leading-none text-ds-border-mid mb-5">
                {num}
              </div>
              <h3 className="font-display font-extrabold text-[22px] uppercase text-ds-text mb-2.5">
                {title}
              </h3>
              <p className="font-sans text-[13px] text-ds-muted leading-[1.7]">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
